module.exports = __webpack_public_path__ + "media/mmusic.43a8ceb4.mp3";